module.exports = "<h2 id=\"component-description\">Component Description</h2>\n<p>A Nessie Form wraps child components and displays a Cancel and Submit button.</p>\n<h2 id=\"example-usage\">Example Usage</h2>\n<pre><code>&lt;Form submitLabel  = &quot;Proceed&quot;\n      discardLabel = &quot;Cancel&quot;&gt;\n    &lt;TextInput label=&quot;Your name&quot;/&gt;\n&lt;/Form&gt;\n</code></pre>";


//////////////////
// WEBPACK FOOTER
// ./node_modules/html-loader!./node_modules/markdown-loader!./src/Form/README.md
// module id = 350
// module chunks = 0